interface OpenPopunderPayload {
  activeTabUrl: string;
  backgroundTabUrl: string;
}

export const usePopunder = () => {
  const openPopunder = (payload: OpenPopunderPayload) => {
    window.open(payload.activeTabUrl, '_blank');
    window.location.href = payload.backgroundTabUrl;
  };

  return {
    openPopunder,
  };
};
